import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, fmtError } from "@/lib/api";
import { PublicHeader } from "@/components/layout/Layout";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const token = sp.get("token") || "";
  const [pwd, setPwd] = useState(""); const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: pwd });
      toast.success("Mot de passe réinitialisé"); nav("/connexion");
    } catch (err) { toast.error(fmtError(err)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-white">
      <PublicHeader />
      <div className="max-w-md mx-auto px-4 py-10">
        <h1 className="text-2xl font-semibold text-[#1F2933]">Nouveau mot de passe</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="label">Nouveau mot de passe</label>
            <input required type="password" minLength={8} className="input" value={pwd} onChange={(e) => setPwd(e.target.value)} data-testid="reset-password" />
          </div>
          <button disabled={busy || !token} className="btn-primary w-full" data-testid="reset-submit">Valider</button>
        </form>
      </div>
    </div>
  );
}
